import React, { useRef, useState } from 'react';
import { IonModal, IonSlides, IonSlide, IonItem, IonInput, IonButton, IonHeader, IonContent, IonGrid, IonRow, IonCol, IonText, IonFooter, IonToolbar, IonTitle, IonButtons, IonBadge, IonList, IonLabel} from '@ionic/react';

import {Application_SubmissionModal} from './Modal_Application_Submission';

import '../../css/layout.css';

export function JobDescriptionModal(props) {

    let [requisition_id, setRequisition_id] = useState(props.data.requisitionID);
    let [requisition_name, setRequisition_name] = useState(props.data.requisitionName);
    let [jobResponsibilites, setJobResponsibilites] = useState(props.data.requisitionResponsibilites);
    let [applicantQualifications, setApplicantQualifications] = useState(props.data.requisitionQualifications);
    let [applicantDeadline, setApplicantDeadline] = useState(props.data.requisitionDeadline);

    let [showApplicationSubmissionnModal, setShowApplicationSubmissionnModal] = useState(false);


    /** Optional: simple helper to render bullets */
        const renderBullets = (text) => {
        if (!text) return null;
        // Split on newlines or bullet-like separators. Tweak as needed.
        const parts = text
            .split(/\r?\n|•|- |\u2022/g)
            .map(s => s.trim())
            .filter(Boolean);
        return (
            <IonList>
            {parts.map((p, i) => (
                <IonItem key={i} lines="none">
                <IonLabel>{p}</IonLabel>
                </IonItem>
            ))}
            </IonList>
        );
        };


    function closeModalHandler() {

        props.closeModal(false);
    }

    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
              <IonHeader>
                    <IonToolbar>
                    <IonTitle>{requisition_name || "Job Details"}</IonTitle>
                    <IonButtons slot="end">
                        <IonButton fill="outline" color="success" onClick={closeModalHandler}>Close</IonButton>
                    </IonButtons>
                    </IonToolbar>
                </IonHeader>

            <IonContent className='appContent'>

                    {/* Meta / ID / Deadline */}
                    <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 12 }}>
                    {requisition_id && <IonBadge color="medium">ID: {requisition_id}</IonBadge>}
                    {applicantDeadline && <IonBadge color="warning">Deadline: {new Date(applicantDeadline).toLocaleDateString("en-US")}</IonBadge>}
                    </div>

                    {/* Responsibilities */}
                    <section className="job-section" style={{ marginBottom: 16 }}>
                    <h2 className="section-title">Responsibilities</h2>
                    {renderBullets(jobResponsibilites)}
                    </section>

                    {/* Qualifications */}
                    <section className="job-section" style={{ marginBottom: 16 }}>
                    <h2 className="section-title">Qualifications</h2>
                    {renderBullets(applicantQualifications)}
                    </section>

                    <Application_SubmissionModal openModal={ showApplicationSubmissionnModal } closeModal={() => setShowApplicationSubmissionnModal(false)} data={{
                    requisitionID: requisition_id, 
                    requisitionName: requisition_name,
                    companyAcctID: props.data.companyAcctID, 
                                        }}></Application_SubmissionModal>
            </IonContent>
            <IonFooter className='grid_footer'>
                <IonGrid>
                    <IonRow>
                        <IonCol>
                            {/* Actions */}
                            <div className="ion-text-end" style={{ marginTop: 12 }}>
                            <IonButton fill="outline" color="success" onClick={() => setShowApplicationSubmissionnModal(true)}>
                                Apply Now
                            </IonButton>
                            </div>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonFooter>

        </IonModal>
        ) : null}
    </React.Fragment>
    )
}
